import e from "../../managers/braze-instance.js";
import { destroyFeedHtml as z } from "../../common/feed-display.js";
export function destroyFeed() {
  if (!e.X()) return;
  const o = document.querySelectorAll(".ab-feed");
  for (let e = 0; e < o.length; e++) z(o[e]);
}
